import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { useActionData } from '@remix-run/react';
import cx from 'classnames';

import Button from '~/components/Button';

interface Props {
  children: React.ReactNode;
  handleRedirect: () => void;
  email?: string;
  promptForEmail?: string;
  setPromptForEmail: (value: string) => void;
  onToggle: () => void;
  isAllSelected: boolean;
}

// When no email exists in local storage, we want to prompt the user to enter their email and then submit the form.
const Continue = ({
  children,
  handleRedirect,
  email,
  promptForEmail,
  setPromptForEmail,
  onToggle,
  isAllSelected,
}: Props) => {
  const { t } = useTranslation();
  const actionData = useActionData();

  useEffect(() => {
    if (actionData?.status === 'success') {
      toast.success(t('toast.success'));
      handleRedirect();
    }
  }, [actionData]);

  return (
    <div className="fixed bottom-0 left-0 flex w-screen flex-col border-t border-gray-200 bg-white px-4 py-6">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between">
        <div className="flex w-full flex-col-reverse items-center justify-between space-x-0 sm:flex-row sm:space-x-4">
          <div className="pt-2 text-center text-sm sm:pt-0">
            <button type="button" onClick={handleRedirect} className="whitespace-nowrap text-xs text-gray-500">
              {t('shared.cta.maybe_later')}
            </button>
          </div>

          <div
            className={cx(
              'flex w-full flex-col space-x-0 space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0',
              email ? 'max-w-sm' : 'max-w-lg',
            )}
          >
            <button
              className="mx-auto w-20 whitespace-nowrap text-xs text-gray-500 underline"
              onClick={onToggle}
              type="button"
            >
              {isAllSelected ? t('shared.cta.deselect_all') : t('shared.cta.select_all')}
            </button>
            {!email && (
              <input
                type="email"
                name="email"
                className="w-full rounded-md border border-gray-300 px-4 py-2 text-sm text-gray-900 placeholder-gray-500"
                required
                value={promptForEmail}
                onChange={(e) => setPromptForEmail(e.target.value)}
                placeholder={t('subscribe.email_placeholder') || ''}
              />
            )}
            <Button type="submit" block>
              {children}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Continue;
